import { useState } from "react";
import classNames from "classnames";
import Plus24PxOutlinedIcon from "@JohnLewisPartnership/jl-design-system/dist/elements/icons-jb/Plus24PxOutlined";
import Minus24PxOutlinedIcon from "@JohnLewisPartnership/jl-design-system/dist/elements/icons-jb/Minus24PxOutlined";
import { TertiaryButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";

import styles from "./TermsAndConditionsAccordion.module.scss";

type TermsAndConditionsAccordionProps = {
  terms: string;
  isVersionTwoPromoDrawer?: boolean;
};

const TermsAndConditionsAccordion = ({
  terms,
  isVersionTwoPromoDrawer = false,
}: TermsAndConditionsAccordionProps) => {
  const [accordionOpen, setAccordionOpen] = useState<boolean>(false);

  const sanitisedTerms = terms.startsWith("</p>")
    ? terms.replace("</p><p>", "<p>") || ""
    : terms;

  return (
    <div
      className={
        isVersionTwoPromoDrawer
          ? styles.newTermsAndConditions
          : styles.termsAndConditions
      }
    >
      <TertiaryButton
        className={
          isVersionTwoPromoDrawer
            ? styles.newTermsAndConditionsButton
            : styles.termsAndConditionsButton
        }
        IconComponent={
          accordionOpen ? Minus24PxOutlinedIcon : Plus24PxOutlinedIcon
        }
        iconPositionRight
        onClick={() => {
          setAccordionOpen(!accordionOpen);
        }}
        data-testid="special-offers-drawer-terms-accordion-button"
        small
      >
        Terms and conditions apply
      </TertiaryButton>
      {accordionOpen && (
        <div
          data-testid="special-offers-drawer-terms-accordion-content"
          className={classNames(styles.accordion)}
          dangerouslySetInnerHTML={{
            __html: sanitisedTerms,
          }}
        ></div>
      )}
    </div>
  );
};

export default TermsAndConditionsAccordion;
